<template>
  <div class="public-footer">
    <div class="footer-banner">
      <div class="banner-info">
        <img class="banner-img" src="~@/assets/images/footer-national-flag.png" alt="">
        <div class="banner-title">
          <p class="title-self">出国留学有疑问？国家、院校、专业如何选？</p>
          <p class="title-text">一对一提供留学方案，超10年以上合作经验助力千余名学生</p>
        </div>
        <div class="banner-ipt">
          <input class="ipt-self" type="text" placeholder="留下您的电话或邮箱" v-model="email" />
          <div class="ipt-btn" @click="submit">获取专属方案</div>
        </div>
      </div>
    </div>
    <div class="footer-content">
      <div class="content-lf">
        <img class="footer-logo" src="~@/assets/images/footer-logo.png" alt="">
        <p class="lf-title">匈牙利留学合作中心是双日教育旗下项目，起源于2003年，前身为匈牙利院校驻华服务中心，受匈院校授权在华开展交流合作，中心与匈教育部下基金会共同成立匈牙利奖学金留学项目，为学生提供最高60%留匈学费减免。17年中心获得匈牙利城市发展部长授予全球杰出贡献合作伙伴。</p>
        <p class="lf-text">地址：江苏省南京市高新区星火路19号星智汇商务花园A5栋9楼</p>
        <p class="lf-text">电话：15312407017</p>
        <p class="lf-text">邮箱：cooperation@istudyedu.com</p>
        <p class="lf-text">微信公众号：匈牙利留学合作中心</p>
      </div>
      <div class="content-item">
        <div class="item-list">
          <p class="list-text">留学申请</p>
          <p class="list-text">留学申请</p>
          <p class="list-text">留学申请</p>
          <p class="list-text">留学申请</p>
          <p class="list-text">留学申请</p>
        </div>
        <div class="item-list">
          <p class="list-text">留学申请</p>
          <p class="list-text">留学申请</p>
          <p class="list-text">留学申请</p>
          <p class="list-text">留学申请</p>
          <p class="list-text">留学申请</p>
        </div>
        <div class="item-list">
          <p class="list-text">留学申请</p>
          <p class="list-text">留学申请</p>
          <p class="list-text">留学申请</p>
          <p class="list-text">留学申请</p>
          <p class="list-text">留学申请</p>
        </div>
      </div>
    </div>
    <div class="footer-copyrights">
      <p class="copyright-text">Copyrights © 2022 南京双日教育科技有限公司 All Rights Reserved / ICP备案：苏ICP备16041064号-5</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'public-footer',
  props: {},
  data () {
    return {
      email: ''
    }
  },
  components: {},
  computed: {},
  created () {},
  watch: {},
  methods: {
    async submit () {
      if (this.email === '') {
        this.$message.error('请输入信息')
        return
      }
      try { 
        const res = await this.$api.post('contacts/update', { email: this.email })
        if (res.code === 200) { 
          this.$message.success(res.message)
          this.email = ''
        }
      } catch (error) {}
    },
  }
}
</script>

<style scoped>
.public-footer{background-color:#fff;}
.footer-banner{background:linear-gradient(to right, #68c298 0%,#198052 25%,#50a47e 75%,#6ac49a 100%);}
.footer-banner .banner-info{display:flex;max-width:1200px;width:100%;margin:0 auto;align-items:center;padding:16px 0;}
.footer-banner .banner-img{display: block;width:103px;margin:0 50px 0 50px;}
.footer-banner .banner-title{padding-right:54px;}
.footer-banner .banner-title .title-self{font-size:24px;color:#fff;line-height:1.5;margin-bottom:10px;font-weight:600;}
.footer-banner .banner-title .title-text{font-size:16px;color:#fff;line-height:1.5;font-weight:400;}
.footer-banner .banner-ipt{display:flex;}
.footer-banner .banner-ipt .ipt-self{width:200px;height:42px;border:1px solid #E3343E;outline:none;border-radius:42px 0 0 42px;padding:0 10px;}
.footer-banner .banner-ipt .ipt-btn{width:100px;line-height:42px;background:#E3343E;color:#fff;cursor:pointer;font-size:14px;text-align:center;border-radius:0 42px 42px 0;}
.footer-content{max-width:1200px;width:100%;margin:0 auto;display:flex;gap:100px;padding:30px 0;}
.footer-content .content-lf{width:500px;color:#808080;font-size:14px;}
.footer-content .footer-logo{width:282px;display:block;margin-bottom:24px;padding-left:56px;}
.footer-content .content-lf .lf-title{margin-bottom:36px;line-height:2;}
.footer-content .content-lf .lf-text{line-height:2;}
.footer-content .content-item{margin-top:48px;display:grid;grid-template-columns: repeat(3, 1fr);gap:80px;color:#808080;font-size:14px;flex:1;}
.footer-content .content-item .list-text{line-height:3;cursor:pointer;}
.footer-copyrights{border-top:1px solid #E5E5E5;padding:20px 0;}
.copyright-text{max-width:1200px;width: 100%;margin: 0 auto;color: #808080;font-size: 14px;;}
</style>
